<template>
  <div class="general">
    <table-cadu
      custom
      v-model="selected"
      nameTab="dirigentesCargos"
      :class="$vuetify.breakpoint.xs ? 'dirigentesCargo-mobile' : 'dirigentesCargo'"
      :loading="isLoading"
      :append-icon="'$vuetify.icons.chevron-down'"
      :showCheck="false"
      :showSelect="false"
      :showFiltro="false"
      :rows="listaCargos"
      :rowsHeader="rowsHeader"
      :elementsPerPageProp="tamanhoPagina"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :ordemProp="ordemDir"
      editar
      :disabledButtons="[
        true,
        nomeAcao === 'EDITAR' || (role !== 'colaborador_brasil' && nomeAcao === 'EDITAR'),
        false,
        false,
        false
      ]"
      :showDownload="false"
      @change-page="(page) => changePage(page)"
      @clickButton="(obj) => clickItem(obj)"
      @ordena="(ordem) => ordenaTable(ordem)"
    />

    <error-modal v-model="showError" :errObj="errObj" />
  </div>
</template>

<script>
import Dirigentes from '@/services/Dirigentes/Dirigentes'

export default {
  props: {
    nomeAcao: {
      type: String,
      default: 'VISUALIZAR',
      validator: (el) => ['VISUALIZAR', 'EDITAR', 'ADICIONAR'].includes(el)
    },
    idDirigente: {
      type: [String, Number],
      default: ''
    },
    role: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: [],
      isLoading: false,
      listaDirigentes: [],
      rowsHeader: [
        { text: 'Código', icon: 'repeat' },
        { text: 'Unimed', icon: 'repeat' },
        { text: 'Cargo', icon: 'repeat' },
        { text: 'Dt. Início', icon: 'repeat' },
        { text: 'Dt. Fim', icon: 'repeat' },
        { text: 'Status' }
      ],
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 5,
      tamanhoPagina: 5,
      barraPesquisa: '',
      showDirigentes: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      dirigentes: '',
      showError: false,
      errObj: {},
      listaCargos: [],
      cloneObj: {},
      ordemDir: 'desc',
      tipoOrdem: ''
    }
  },
  async beforeMount() {
    this.pagina = 1
    this.dirigentes = new Dirigentes(this.tokenBearer, this.$appConfig.config.API)
    await this.getTabela()
  },
  methods: {
    ordenaTable(obj) {
      this.ordemDir = obj.ordem
      switch (obj.index) {
        case 0:
          this.tipoOrdem = 'unimed.id'
          break
        case 1:
          this.tipoOrdem = 'unimed.versaoAtiva.dadosCadastrais.nomeFantasia'
          break
        case 2:
          this.tipoOrdem = 'dirigenteCargo.cargo.nome'
          break
        case 3:
          this.tipoOrdem = 'mandato.dataInicioVigencia'
          break
        case 4:
          this.tipoOrdem = 'mandato.dataFimVigencia'
          break
        default:
          this.tipoOrdem = ''
          break
      }
      this.getTabela()
    },
    async getTabela() {
      this.isLoading = true
      let res = await this.promiseGeneric(
        this.dirigentes,
        'getDirigentesCargo',
        this.idDirigente,
        `pagina=${this.pagina}&ordenacao=${this.tipoOrdem}&direcaoOrdenacao=${this.ordemDir}`
      )
      this.isLoading = false
      res = res.data

      this.listaCargos = res.conteudo
      this.qtPaginas = res.qtPaginas
      this.qtResultados = res.qtResultados
    },
    async promiseGeneric(className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.isLoading = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    changePage(page) {
      this.pagina = page.currentPage
      this.getTabela()
    },
    clickItem(obj) {
      const index = obj.index
      const objInfo = {
        idDirigenteCargo: this.listaCargos[index].dirigenteCargo.id,
        idMandato: this.listaCargos[index].mandato.id,
        idUnimed: this.listaCargos[index].unimed.id
      }
      switch (obj.type) {
        case 'view':
          this.$emit('view', objInfo)
          break
        case 'edit':
          this.$emit('edit', objInfo)
          break
      }
    }
  }
}
</script>

<style lang="sass">
.general
    color: rgba(0, 0, 0, 0.54)
    font-size: 0.875rem !important
    line-height: 1.375rem !important
    letter-spacing: 0.0071428571em

.dirigentesCargo-mobile > .table-cadu
    padding-bottom: 0px
    padding: 20px 10px !important
    border: none
    border-radius: 0px
    width: 100% !important

.dirigentesCargo > .table-cadu
    padding-bottom: 0px
    padding-left: 0px
    border: none
    border-radius: 0px
    width: 100% !important

.dirigentesCargo > .table-cadu > .table > table
    width: 100% !important

.dirigentesCargo-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
